import React, { memo, ReactElement } from "react";
import styles from "../BillDetailItem.scss";

const TransparentLine = (): ReactElement => {
    return <div className={styles.transparentLine} />;
};

export default memo(TransparentLine);
